export default {
  setUser(state, payload) {
    state.user = payload
  },

  setEmpresaPrincipal(state, payload) {
    state.empresaPrincipal = payload
  },

  setGrupoPrincipal(state, payload) {
    state.grupoPrincipal = payload
  },

  setPrefix(state, payload) {
    state.prefix = payload
  },

  setPapel(state, payload) {
    state.papel = payload
  }
}
